import React from "react";
import "./DoctorCard.css";
import Green_btn from "../common_btn/green_btn/Green_btn";
import { Rating } from "react-simple-star-rating";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../../utils/common";

function DoctorCard({
  image,
  category,
  name,
  hospital,
  buttonText = "Consult Now",
  price,
  similarDr = false,
  id,
  average_rating,
  item,
}) {
  const navigate = useNavigate();
  return (
    <div className="DoctorCard-section">
      <div
        onClick={() => navigate(`/doctor-detail/${encodeId(id)}`)}
        style={{ cursor: "pointer" }}
      >
        <div className="card_img">
          <img src={image} alt={name} />
        </div>
      </div>

      <div className="card_body">
        <div
          onClick={() => navigate(`/doctor-detail/${encodeId(id)}`)}
          style={{ cursor: "pointer" }}
        >
          <span className="category">{category}</span>
          <h3 className="name">{name}</h3>
          <p className="hospital">{hospital}</p>
        </div>
        {/* <div className="doctor_rating_wrapper">
          <Rating initialValue={5} readonly size={18} allowFraction />

          <span className="doctor_review_text">(20)</span>
        </div>
        <p className="price">{price}</p> */}
        {similarDr && (
          <>
            <div className="doctor_rating_wrapper">
              <Rating
                // initialValue={5}
                initialValue={Number(average_rating)}
                readonly
                size={18}
                allowFraction
              />

              <span className="doctor_review_text">
                ({Number(average_rating || 0)})
              </span>
            </div>

            <p className="price">₹{price}</p>

            <div className="green-bg">
              <Green_btn
                btnText="Book Now"
                onClick={() => navigate(`/doctor-detail/${encodeId(id)}`)}
              />
            </div>
          </>
        )}
        {/* <Green_btn btnText="Consult Now" />
        <div className="green-bg">
          {" "}
          <Green_btn btnText="Book Now" />
        </div> */}{" "}
        {!similarDr && (
          <Green_btn
            btnText={buttonText}
            onClick={() => navigate(`/doctor-detail/${encodeId(id)}`)}
          />
        )}
      </div>
    </div>
  );
}

export default DoctorCard;
